module.exports = require('./lib/_stream_duplex.js');



//////////////////
// WEBPACK FOOTER
// ./node_modules/readable-stream/duplex-browser.js
// module id = 137
// module chunks = 0 1